import { DeliverableDataIguide } from '~common/model/Deliverable';

export default function DeliverableRenderIguide({ data }: { data: DeliverableDataIguide }): JSX.Element {
  return (
    <iframe
      src={data.url}
      allowFullScreen
      allow="xr-spatial-tracking"
      className="w-full h-full overflow-hidden bg-black"
    />
  );
}
